import { gray, warning } from "../../../../utils/constants"

export const genderSection = { maxWidth:'240px', marginLeft:'-20px',fontSize:'85%' ,padding:'0' }
export const exportButton = { width:'180px',height:'32px',padding:'0',borderRadius:'2px',color:'green',marginTop:'-5px', borderColor:'green', borderWidth:'1px' }
export const warningStyle = { color:warning, fontWeight:'bold',marginLeft:'-110px', marginTop:'-30px' }
export const jvDivision =  'col-lg-2 col-md-2'
export const jv = { marginLeft:'-15px',marginRight:'15px', fontWeight:'bold',textDecoration:'underline' }
export const headerSection = { border:`1px solid ${gray}`,padding:'10px 0 0 20px',marginBottom:'10px' }
export const nonMember = { color:warning,display:'inline-block',verticalAlign:'middle', paddingTop:'15px',marginLeft:'3px',fontSize:'18px' }
export const eventMinsWarning = { padding:'0 5px 0 5px',fontWeight:'bold', color:warning }
export const btnSchoolSearch = { marginLeft:'-62px',minHeight:'35px',maxWidth:'35px',borderLeft:'none', borderRadius:'0 4px 4px 0', paddingLeft:'10px' }
export const jvSection = { border:'0.5px solid rgb(235,235,235)',paddingBottom:'7px', minWidth:'190px', marginTop:'2px',maxHeight:'35px' , fontSize:'85%' }
export const btnSchoolNotFound = {   marginLeft:'-10px',minHeight:'40px',marginTop:'-3px',fontSize:'125%' }
export const iconSchoolNotFound = {  color:'white' }
export const imageIconColor  = { color:'black' }
export const searchBackground = { backgroundColor:gray }
export const headerLabel = { paddingLeft:'15px', paddingBottom:'0', marginBottom:'0' }


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/Participants/style.js